import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Modal } from '@mui/material';
import { StyledModalContainer } from './style';
export const CustomModal = ({ open, onCloseHandle, preventClosing, minWidth, maxWidth, width, children, }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const handleClose = (event, reason) => {
        if (!preventClosing) {
            setModalOpen(false);
            onCloseHandle(null);
        }
    };
    useEffect(() => {
        setModalOpen(open);
    }, [open]);
    return (_jsx(Modal, Object.assign({ open: modalOpen, onClose: handleClose, "aria-labelledby": "parent-modal-title", "aria-describedby": "parent-modal-description" }, { children: _jsx(StyledModalContainer, Object.assign({ width: width, minWidth: minWidth, maxWidth: maxWidth }, { children: children })) })));
};
